var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["Link"]: () => (__WEBPACK_EXTERNAL_MODULE_react_router_dom_a27720b7__.Link), ["NavLink"]: () => (__WEBPACK_EXTERNAL_MODULE_react_router_dom_a27720b7__.NavLink) });